const formatSimple = (date) => {
  if (!date) {
    return null;
  }
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
};

const formatTime = (time) => {
  if (!time) {
    return '';
  }
  const [hour] = time.split('.');
  return hour;
};

const formatTimeHourMinute = (time) => {
  if (!time) {
    return '';
  }
  const [hour, minute] = time.split(':');
  return `${hour}:${minute}`;
};

const formatDateTime = (sDate, includeTime) => {
  if (!sDate) {
    return null;
  }
  let splitter = 'T';
  if (!sDate.includes('T')) {
    splitter = ' ';
  }
  const [date, hour] = sDate.split(splitter);
  if (includeTime) {
    return `${formatSimple(date)} ${formatTime(hour)}`;
  }

  return formatSimple(date);
};

export default {
  formatSimple,
  formatDateTime,
  formatTime,
  formatTimeHourMinute,
};
